import { createFileRoute } from "@tanstack/react-router";
import { NewExpeditionPage } from "~/pages/expeditions/NewExpeditionPage";
export const Route = createFileRoute("/_authenticated/expeditions/new")({ component: NewExpeditionPage });
